import React from 'react';

export const Logo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={`${className} relative flex items-center justify-center`}>
      <svg 
        viewBox="0 0 100 100" 
        className="w-full h-full"
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="brand-grad" x1="0" y1="0" x2="100" y2="100">
            <stop offset="0%" stopColor="#0A2540" />
            <stop offset="100%" stopColor="#2ECC71" />
          </linearGradient>
        </defs>
        
        {/* Document Shape */}
        <path 
          d="M30 15 H60 L75 30 V85 H30 Z" 
          fill="white" 
          stroke="#0A2540" 
          strokeWidth="4" 
          strokeLinejoin="round"
        />
        
        {/* Shield Overlay */}
        <path 
          d="M50 45 Q50 45 70 40 V60 Q50 75 50 75 Q50 75 30 60 V40 Q50 45 50 45" 
          fill="#0A2540"
        />
        
        {/* Checkmark */}
        <path 
          d="M42 58 L48 64 L58 52" 
          stroke="#2ECC71" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};